import { FC } from 'react'
import { Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { dynamicRoutes } from '../../../../../constants/routes'

interface Props {
    id: string
}

const ClientActionsEdit: FC<Props> = ({ id }) => {
    const navigate = useNavigate()
    return (
        <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() => navigate(dynamicRoutes.clientsEdit(id))}
            color="blue"
            variant="outlined"
            title="Редактировать"
        />
    )
}

export default ClientActionsEdit
